import HttpService from "./htttp.service";

class ModulesService {
  getModules = async (payload, cancelToken) => {
    const endpoint = "modules";
    return await HttpService.get(endpoint, payload, cancelToken);
  };
}

export default new ModulesService();
